import { useState } from 'react'
import type { FormEvent } from 'react'
import type { PuzzleRendererProps } from '@/game/PuzzleRenderer'

type Config = { placeholder?: string; maxLength?: number }

/** Free-text answer. Submits { text: string }; the server normalises and checks it. */
export function TextPuzzle({ puzzle, onSubmit, disabled }: PuzzleRendererProps) {
  const config = puzzle.publicConfig as Config
  const [text, setText] = useState('')

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (text.trim() === '') return
    void onSubmit({ text: text.trim() })
  }

  return (
    <form onSubmit={handleSubmit} className="puzzle-form">
      <div className="field">
        <label htmlFor={`answer-${puzzle.id}`}>Your answer</label>
        <input
          id={`answer-${puzzle.id}`}
          type="text"
          autoComplete="off"
          autoCapitalize="none"
          enterKeyHint="send"
          placeholder={config.placeholder}
          maxLength={config.maxLength ?? 500}
          value={text}
          onChange={(e) => setText(e.target.value)}
          disabled={disabled}
        />
      </div>
      <button type="submit" className="primary" disabled={disabled || text.trim() === ''}>
        {disabled ? 'Checking…' : 'Submit answer'}
      </button>
    </form>
  )
}
